import { WorkspaceFlavour } from '@affine/env/workspace';
import type { WorkspaceService } from '@toeverything/infra';
import { Service } from '@toeverything/infra';

import { ShareDocsList } from '../entities/share-docs-list';

export class ShareDocsListService extends Service {
  constructor(private readonly workspaceService: WorkspaceService) {
    super();
  }

  shareDocs =
    // DNB_NEW_NAMES_FIX
    this.workspaceService.workspace.flavour === WorkspaceFlavour.DNB_CLOUD
      ? this.framework.createEntity(ShareDocsList)
      : null;

  override dispose(): void {
    this.shareDocs?.dispose();
  }
}
